import {
  REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_DWELLERS,
  REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_OTHERS,
  REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_PROVIDERS,
  REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_AUDIENCE,
} from '../RequestProfileTabEmails.constants'

export const REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_FIELD_NAME =
  REQUEST_PROFILE_TAB_EMAILS_FILTER_KEY_AUDIENCE

export const REQUEST_PROFILE_TAB_EMAILS_MOVE_TO_TAB_OPTIONS = [
  REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_PROVIDERS,
  REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_DWELLERS,
  REQUEST_PROFILE_TAB_EMAILS_AUDIENCE_OTHERS,
]
